(() => {
  "use strict";

  // —————————————————————————————————————————————————————————————————————————
  // 1) ATC + cart-drawer integration
  async function handleBundleAtc(form) {
    const btn = form.querySelector(".kaching-atc-trigger");
    if (btn.__bound) return;
    btn.__bound = true;

    btn.addEventListener("click", async (e) => {
      e.preventDefault();

      const cartV4 = window.cartV3 || window.cartV4;

      // When V4 is active, skip real /cart/add.js — go straight to virtual cart
      if (cartV4) {
        // Kaching doesn't reliably update input[name="id"] — read from multiple sources
        const kachingComponent = form.querySelector("kaching-bundle");
        const selectedPickerBar = form.querySelector(".m-picker-bar--selected");
        const hiddenIdInput = form.querySelector('input[name="id"]');

        // Priority: 1) selected picker bar, 2) kaching component attribute, 3) hidden input
        const variantId =
          selectedPickerBar?.dataset?.variantId ||
          kachingComponent?.getAttribute("current-variant-id") ||
          hiddenIdInput?.value ||
          null;

        // Subscription: check our custom m-subscription-checkbox (not Kaching's native)
        const subCheckbox = form.querySelector(".m-subscription-checkbox, [data-subscription-checkbox]");
        const isSubscription = subCheckbox?.checked === true;

        // Get selling plan from picker-variants JSON data — match frequency to pack size
        let sellingPlanId = null;
        if (isSubscription && variantId) {
          const pickerDataEl = form.querySelector("[data-picker-variants]");
          if (pickerDataEl) {
            try {
              const pickerData = JSON.parse(pickerDataEl.textContent);
              const variant = pickerData.variants?.find(
                (v) => String(v.id) === String(variantId)
              );
              if (variant) {
                const packSize = variant.pack_size || 1;
                const target = packSize + " month";
                const allocations = variant.selling_plan_allocations || [];
                const matched = allocations.find(
                  (a) => a.name && a.name.toLowerCase().includes(target)
                );
                sellingPlanId = matched ? matched.selling_plan_id : variant.selling_plan_id;
              }
            } catch (err) {
              console.warn("[Kaching] Failed to parse picker variants:", err);
            }
          }
        }

        console.log("[Kaching] V4 ATC:", {
          variantId,
          sellingPlanId,
          isSubscription,
          source: selectedPickerBar ? "picker-bar" : kachingComponent ? "kaching-attr" : "hidden-input"
        });

        if (variantId) {
          document.dispatchEvent(
            new CustomEvent("cart-v4:add", {
              detail: {
                variantId: parseInt(variantId, 10),
                quantity: 1,
                sellingPlanId: sellingPlanId ? parseInt(sellingPlanId, 10) : null
              },
            })
          );
        } else {
          cartV4.open();
        }
        return;
      }

      // Fallback: real /cart/add.js for non-V4 carts
      const formData = new FormData(form);

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        });
        if (!res.ok) throw new Error("Add to cart failed");

        const cartAPI = window.cartAPI;

        if (cartAPI?.manager) {
          await cartAPI.manager.forceRefresh();
          await cartAPI.manager.openCartDrawer();
        } else if (window.cartManager) {
          await cartManager.buildCart();
          await cartManager.openCartDrawer();
        } else {
          window.location.href = "/cart";
        }
      } catch (err) {
        console.error("[Kaching] integration error:", err);
        window.location.href = "/cart";
      }
    });
  }

  // —————————————————————————————————————————————————————————————————————————
  // 2) Hide zero-savings labels
  function hideZeroSavings() {
    document
      .querySelectorAll(
        ".kaching-bundles__bar-subtitle, .kaching-bundles__header-subtitle"
      )
      .forEach((el) => {
        const t = el.textContent.trim();
        const isPercentZero = /^You Save\s*0%?$/.test(t);
        const isMoneyZero = /^Save\s*\$0(?:\.0{1,2})?$/.test(t);
        if (isPercentZero || isMoneyZero) {
          el.style.display = "none";
        } else {
          el.style.display = "";
        }
      });
  }

  function observeSavings() {
    hideZeroSavings();
  }

  // —————————————————————————————————————————————————————————————————————————
  // 3) FREE GIFT LINE + DELIVERY LINE
  function initFreeGiftLine() {

    let bundleBlock = document.querySelector(
      ".kaching-style--v3-orange-black kaching-bundles-block, .kaching-style--v3-orange-black-2 kaching-bundles-block"
    );

    if (!bundleBlock) {
      bundleBlock = Array.from(
        document.querySelectorAll("kaching-bundles-block")
      ).find((b) => {
        const bars = b.querySelectorAll(".kaching-bundles__bar");
        if (bars.length !== 2) return false;
        const titles = Array.from(bars).map(
          (br) =>
            br.querySelector(".kaching-bundles__bar-title")?.textContent?.toLowerCase() ||
            ""
        );
        const has30 = titles.some(
          (t) => t.includes("30 day") && t.includes("supply")
        );
        const has90 = titles.some(
          (t) => t.includes("90 day") && t.includes("supply")
        );
        return has30 && has90;
      });
    }

    if (!bundleBlock) return;

    const isStyle1 =
      bundleBlock.closest(".kaching-style--v3-orange-black") !== null;
    const isStyle2 =
      bundleBlock.closest(".kaching-style--v3-orange-black-2") !== null;

    const giftCount = isStyle1 ? 2 : isStyle2 ? 1 : 0;

    function ensureGiftLines() {
      const bars = bundleBlock.querySelectorAll(".kaching-bundles__bar");

      bars.forEach((bar, index) => {
        const contentLeft = bar.querySelector(".kaching-bundles__bar-content-left");
        const secondLine = bar.querySelector(".kaching-bundles__bar-second-line");

        if (!contentLeft || !secondLine) return;

        if (giftCount > 0) {
          const giftText =
            giftCount === 1 ? "1 FREE Gift" : `${giftCount} FREE Gifts`;

          let thirdLine = contentLeft.querySelector(".kaching-bundles__bar-third-line");
          if (!thirdLine) {
            thirdLine = document.createElement("div");
            thirdLine.className = "kaching-bundles__bar-third-line";
            thirdLine.innerHTML = `
              <div class="kaching-free-gift-subtitle">
                <span class="kaching-free-gift-emoji" aria-hidden="true">🎁</span>
                <span></span>
              </div>
            `;
            secondLine.after(thirdLine);
          }

          const span = thirdLine.querySelector(
            ".kaching-free-gift-subtitle span:last-child"
          );
          if (span && span.textContent !== giftText) {
            span.textContent = giftText;
          }
        } else {
          const stale = contentLeft.querySelector(".kaching-bundles__bar-third-line");
          if (stale) stale.remove();
        }

        const deliveryText =
          index === 0
            ? "Delivery every month"
            : "Delivery every 3 months";

        let fourthLine = contentLeft.querySelector(".kaching-bundles__bar-fourth-line");
        if (!fourthLine) {
          fourthLine = document.createElement("div");
          fourthLine.className = "kaching-bundles__bar-fourth-line";
          fourthLine.innerHTML = `
            <div class="kaching-free-delivery-subtitle">${deliveryText}</div>
          `;

          const third = contentLeft.querySelector(".kaching-bundles__bar-third-line");
          if (third) third.after(fourthLine);
          else secondLine.after(fourthLine);
        } else {
          const dsub = fourthLine.querySelector(".kaching-free-delivery-subtitle");
          if (dsub && dsub.textContent !== deliveryText) {
            dsub.textContent = deliveryText;
          }
        }
      });
    }

    function updateVisibility() {
      const subsRoot = bundleBlock.querySelector(".kaching-bundles__subscriptions");
      const form =
        bundleBlock.closest("form.kaching-bundle-form") ||
        document.querySelector("form.kaching-bundle-form");

      const sellingPlanInput = form?.querySelector(
        'input[name="selling_plan"][value]:not([value=""])'
      );

      const isSubscriptionChecked = Boolean(
        subsRoot?.querySelector('[aria-checked="true"]') ||
          subsRoot?.querySelector(".kaching-bundles__bar--selected") ||
          subsRoot?.querySelector(".kaching-bundles__bar-container--selected") ||
          sellingPlanInput
      );

      const lines = bundleBlock.querySelectorAll(
        ".kaching-bundles__bar-third-line, .kaching-bundles__bar-fourth-line"
      );
      lines.forEach((line) => {
        if (isSubscriptionChecked) line.classList.add("visible");
        else line.classList.remove("visible");
      });
    }

    let updateTimer;
    function scheduleUpdate(delay = 60) {
      clearTimeout(updateTimer);
      updateTimer = setTimeout(() => {
        ensureGiftLines();
        updateVisibility();
      }, delay);
    }

    scheduleUpdate(120);

    const subscriptionCard = bundleBlock.querySelector(
      ".kaching-bundles__subscriptions__card"
    );
    if (subscriptionCard) {
      subscriptionCard.addEventListener("click", () => scheduleUpdate(50));
      const subsObserver = new MutationObserver(() => scheduleUpdate(30));
      subsObserver.observe(subscriptionCard, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    const form =
      bundleBlock.closest("form.kaching-bundle-form") ||
      document.querySelector("form.kaching-bundle-form");
    if (form) {
      form.addEventListener("change", (e) => {
        if (e.target && e.target.name === "selling_plan") scheduleUpdate(20);
      });
      const sp = form.querySelector('input[name="selling_plan"]');
      if (sp && !sp.__obs) {
        const spObs = new MutationObserver(() => scheduleUpdate(20));
        spObs.observe(sp, { attributes: true, attributeFilter: ["value"] });
        sp.__obs = spObs;
      }
    }

    if (!bundleBlock.__freeGiftObserver) {
      const blockObserver = new MutationObserver(() => scheduleUpdate(80));
      blockObserver.observe(bundleBlock, { childList: true, subtree: true });
      bundleBlock.__freeGiftObserver = blockObserver;
    }
  }

  // —————————————————————————————————————————————————————————————————————————
  // 4) Relocate doctor endorsement on mobile
  function relocateDoctorEndorsement() {
    if (window.innerWidth > 768) return;
    const picker = document.querySelector(
      ".kaching-picker-v2, .kaching-picker-v3"
    );
    const review = document.querySelector(".md_img_review_box");
    const usps = document.querySelector(".DesktopNotTabletMobile_only");
    if (!picker || !review || !usps || review.dataset.moved) return;

    usps
      .querySelectorAll(".md_divider")
      .forEach((d) => d.style.setProperty("display", "none", "important"));

    review.dataset.moved = "true";
    const wrap = document.createElement("div");
    wrap.className = "Mobile_only";
    usps.after(wrap);
    wrap.appendChild(review);
  }

  // —————————————————————————————————————————————————————————————————————————
  // 5) Fix cart variant titles
  function fixCartVariantTitles() {
    const c =
      window.cartAPI?.manager?.cart || window.cartAPI?.manager?.currentCart;
    if (c?.items) {
      _apply(c.items);
    } else {
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => _apply(cart.items))
        .catch(() => {});
    }
  }

  function _apply(items) {
    document.querySelectorAll(".md_cart_item").forEach((el) => {
      const id = Number(el.dataset.id);
      const line = items.find((i) => i.id === id);
      if (!line) return;

      const planName =
        line.selling_plan_name ||
        line.selling_plan_allocation?.selling_plan?.name ||
        "One-Time Purchase";

      const badge = el.querySelector(".md_cart_item_qty_badge");
      const qty = badge
        ? parseInt(badge.textContent.replace(/\D/g, ""), 10) || 0
        : 0;

      const variantTitle = (line.variant_title || line.title || "").toLowerCase();
      const isBag = variantTitle.includes("bag");
      const suffix = isBag
        ? (qty === 1 ? "Bag" : "Bags")
        : (qty === 1 ? "Bottle" : "Bottles");

      const display = `${qty} ${suffix} | ${planName}`;

      const titleEl = el.querySelector(".md_cart_item_variant_title");
      if (titleEl && titleEl.textContent.trim() !== display) {
        titleEl.textContent = display;
      }

      const isFree = line.line_price === 0 || line.price === 0;
      el.closest(".md_cart_item_box").dataset.free = isFree;
    });
  }

  let cartObserver;
  function observeCartTitles() {
    const any = document.querySelector(".md_cart_item_box");
    if (!any || cartObserver) return;
    cartObserver = new MutationObserver(() => {
      clearTimeout(cartObserver._t);
      cartObserver._t = setTimeout(fixCartVariantTitles, 100);
    });
    cartObserver.observe(any.parentElement, { childList: true, subtree: true });
  }

  // —————————————————————————————————————————————————————————————————————————
  // 6) Reorder paid before free
  function reorderCartItems() {
    const container = document.querySelector(".md_cart_items");
    if (!container) return;

    const paid = [];
    const free = [];

    Array.from(container.children).forEach((box) => {
      const span = box.querySelector(".md_cart_item_price span");
      const txt = span?.textContent.trim() || "";

      if (txt.startsWith("$0")) free.push(box);
      else paid.push(box);
    });

    paid.concat(free).forEach((box) => container.appendChild(box));
  }

  // —————————————————————————————————————————————————————————————————————————
  // 7) Patch drawer-open
  function patchDrawerOpen() {
    if (window.cartAPI?.manager?.openCartDrawer) {
      const orig = cartAPI.manager.openCartDrawer.bind(cartAPI.manager);
      cartAPI.manager.openCartDrawer = async (...args) => {
        const ret = await orig(...args);
        setTimeout(initCartFixer, 200);
        return ret;
      };
    }
    if (window.cartManager?.openCartDrawer) {
      const o2 = cartManager.openCartDrawer.bind(cartManager);
      cartManager.openCartDrawer = async (...args) => {
        const ret = await o2(...args);
        setTimeout(initCartFixer, 200);
        return ret;
      };
    }
  }

  // —————————————————————————————————————————————————————————————————————————
  // 8) Observe drawer "active"
  function observeDrawerOpen() {
    const out = document.querySelector(".md_cart_drawer_outer");
    if (!out || out.__obs) return;
    out.__obs = new MutationObserver(() => {
      if (out.classList.contains("active")) initCartFixer();
    });
    out.__obs.observe(out, { attributes: true, attributeFilter: ["class"] });
  }

  function initCartFixer() {
    fixCartVariantTitles();
    observeCartTitles();
    reorderCartItems();
  }

  // —————————————————————————————————————————————————————————————————————————
  // 9) Bootstrap
  function initAll() {
    document.querySelectorAll(".kaching-bundle-form").forEach(handleBundleAtc);

    hideZeroSavings();
    observeSavings();
    initFreeGiftLine();
    relocateDoctorEndorsement();
    patchDrawerOpen();
    observeDrawerOpen();
    setTimeout(initCartFixer, 200);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
  window.addEventListener("resize", relocateDoctorEndorsement);

  if (window.customElements?.whenDefined) {
    customElements
      .whenDefined("kaching-bundles-block")
      .then(() => setTimeout(initAll, 100))
      .catch(() => {});
  }
})();